import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { isLocalApi } from 'utils/localApi';

/**
 * How much of the files bucket the project's business holds in its project
 * bank, summed by the backend from the S3 objects under the business's
 * prefix (a project without a business counts its own prefix).
 * @param {string} projectId
 * @returns {Promise<{scope: 'BUSINESS'|'PROJECT', businessId: string|null, projectKey: string, prefix: string, usedBytes: number, objectCount: number, complete: boolean, computedAt: string, cached: boolean}>}
 */
export const getProjectBankStorageUsage = async (projectId) => {
  const apiPath = `project-bank/${projectId}/storage-usage`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    isLocalApiRequest: isLocalApi(process.env.REACT_APP_LOCAL_API_PROJECT_BANK),
  });

  const response = await axios(signedRequest);

  return response.data;
};
